import { request } from './client';

export interface RecentTopup {
  id: string;
  amountNgonka: string;
  txHash: string | null;
  createdAt: string;
  balanceAfter: string;
}

export interface DepositInfo {
  address: string;
  denom: 'ngonka';
  minNgonka: string;
  memo: string;
  paymentUri: string;
}

export interface StdSignDoc {
  chain_id: string;
  account_number: string;
  sequence: string;
  fee: { amount: Array<{ denom: string; amount: string }>; gas: string };
  msgs: Array<{ type: string; value: Record<string, unknown> }>;
  memo: string;
}

export interface PrepareTxResponse {
  signDoc: StdSignDoc;
  accountNumber: string;
  sequence: string;
  chainId: string;
}

export interface BroadcastTxResponse {
  txHash: string;
  code: number;
  rawLog: string;
}

export interface StdSignature {
  pub_key: { type: string; value: string };
  signature: string;
}

export const topupApi = {
  getDepositInfo: () => request<DepositInfo>('/api/topups/my-deposit-info'),
  getRecent: (limit = 20) =>
    request<RecentTopup[]>(`/api/topups/recent?limit=${encodeURIComponent(String(limit))}`),
  prepareTx: (body: { senderAddress: string; amountNgonka: string }) =>
    request<PrepareTxResponse>('/api/topups/prepare-tx', { method: 'POST', body }),
  broadcastTx: (body: { signed: StdSignDoc; signature: StdSignature }) =>
    request<BroadcastTxResponse>('/api/topups/broadcast-tx', { method: 'POST', body }),
};
